<template>
  <div style="max-width: 1200px; margin: 0 auto;">
    <div class="dashboard-title dashboard-title--basic mb-md">
      <div class="dashboard-title__actions">
        <div>
          <h1 class="fw-bold fs-xl mb-xs">
            Get Listed in More Agencies Directories
          </h1>
          <p class="fc-darker fs-md mr-lg">
            Easiest way to get discovered by new clients
          </p>
        </div>
      </div>
    </div>
    <div class="table-toolbar" style="margin-left: -6px;">
      <label class="searcher">
        <input
          data-hj-allow
          type="text"
          @input="updateQueryAndFilter($event.target.value)"
          :value="query"
          placeholder="Search"
        />
      </label>
      <span v-if="query">
        Cant find a vendor?
        <router-link to="/agency/send-invitation" class="fc-violet"
          >Send an Invitation</router-link
        >
        instead.
      </span>
    </div>
    <div class="grid">
      <div class="list">
        <div class="grid__cell">
          <div class="list grid list--grid">
            <VendorCard
              v-for="partner in getPartners"
              :key="partner.id"
              :data="partner"
            />
          </div>
        </div>
      </div>
    </div>
    <smart-pagination
      :currentPage.sync="currentPage"
      :count="count"
      :pageSize="pageSize"
      v-on:update:currentPage="pageChanged($event)"
    />
  </div>
</template>

<script>
import VendorCard from '@/components/AgencyDashboard/VendorCard';
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers(
  'findPartners'
);

export default {
  components: {
    VendorCard,
  },
  computed: {
    ...mapGetters(['getPartners', 'query']),
    ...mapState(['pageSize', 'count', 'currentPage']),
  },
  created() {
    this.fetchPartners(1);
  },
  methods: {
    ...mapActions(['fetchPartners', 'updateQueryAndFilter', 'setCurrentPage']),
    pageChanged(page) {
      this.setCurrentPage(page);
      this.fetchPartners(page);
    },
  },
};
</script>
